// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"146":"vue-swiper","151":"plato-map"}[chunkId] + ".js?id=" + {"146":"76126d036d22d9a9","151":"15dc1291d912f436"}[chunkId] + "";
};